import styled from 'styled-components'

export default styled.header`
  padding: 10px;

  & h2 {
    margin: 0;
    padding: 0;
  }
  &>div {
    display: flex;
    justify-content: space-between;
  }
`



// WEBPACK FOOTER //
// ./src/components/Dashboard/Header.js